'use strict';

export default class PostalcodeValidate {
    constructor() {
        this.elementData = '[data-postal-code=true]';
        this.element = document.querySelector(this.elementData);
        this.regexPostalcode = /(^\d{5}|keine)$/;
        this.events = {
            focus: 'focus',
            focusout: 'focusout',
            keypress: 'keypress',
            paste: 'paste'
        };
    }

    // initialize module
    init() {
        // early exit
        if (this.element === null) {
            return false;
        }

        // select all content in postal code input field
        this.element.addEventListener(this.events.focus, (e) => {
            e.currentTarget.setSelectionRange(0, e.currentTarget.value.length);
        });

        this.element.addEventListener(this.events.focusout, () => {
            this._setPostalcodeValue(this.validatePostalcode(this._getPostalcodeValue()));
        });

        this.element.addEventListener(this.events.keypress, (e) => {
            const pressedKey = !e.charCode ? e.charCode : e.which;
            if (!this._disableIllegalCharacterInput(String.fromCharCode(pressedKey))) {
                e.preventDefault();
            }
        });

        // don't allow paste in the input field to prevent forbidden characters.
        this.element.addEventListener(this.events.paste, (e) => {
            e.preventDefault();
        });
    }

    _setPostalcodeValue(value) {
        this.element.value = value.replace(/\./g, '');
    }

    _getPostalcodeValue() {
        return this.element.value;
    }

    _disableIllegalCharacterInput(inputVal) {
        return RegExp(/^[\d]+/).test(inputVal);
    }

    validatePostalcode(value) {
        return (!RegExp(this.regexPostalcode).test(value) || value === '' || typeof (value) === 'undefined') ? '' : value;
    }
}
